import { Box } from "@mui/material";

// img
import mailIcon from "../../../../assets/svg/contact/ic-mail.svg";
import phoneIcon from "../../../../assets/svg/contact/ic-phone.svg";
import rightArrow from "../../../../assets/svg/arrows/arrow-right-light.svg";
import icPhoto from "../../../../assets/svg/action/ic-photo-white.svg";
import icCross from "../../../../assets/svg/action/ic-cross-white.svg";
import icCorrect from "../../../../assets/svg/action/ic-correct-white.svg";
import icPen from "../../../../assets/svg/action/ic-edit-pen-white.svg";
import avatar from "../../../../assets/png/avatarProfile.png";
import brokenImg from "../../../../assets/png/brokenImg.png";
import { capitalizeWords } from "../../../../util/helper";
import React, { useState } from "react";
import decryptUrl from "../../../../util/img-decryption";
import { Container, InputCheckbox, Tooltip } from "@jds/core";

const customFieldsShow = (customFields, field) => {
  if (
    customFields?.[field.id]?.type === "text" ||
    customFields?.[field.id]?.type === "dropdown" ||
    customFields?.[field.id]?.type === "radio" ||
    customFields?.[field.id]?.type === "date" ||
    customFields?.[field.id]?.type === "paragraph"
  ) {
    return (
      <>
        <Tooltip
          label={customFields?.[field.id]?.questionName}
          position="bottom"
        >
          <p
            style={{
              whiteSpace: "nowrap",
              maxWidth: "250px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              textAlign: "left",
            }}
          >
            <b>{customFields?.[field.id]?.questionName}:</b>
          </p>
        </Tooltip>
        <Tooltip
          label={customFields?.[field.id]?.questionName + ": " + field.value}
          position="bottom"
        >
          <p
            style={{
              whiteSpace: "nowrap",
              maxWidth: "250px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              textAlign: "left",
            }}
          >
            {field.value}
          </p>
        </Tooltip>
      </>
    );
  }
  if (customFields?.[field.id]?.type === "consent") {
    return (
      <>
        <Tooltip
          label={customFields?.[field.id]?.questionName}
          position="bottom"
        >
          <Container gap={8}>
            <InputCheckbox checked={field.value} disabled />
            <p
              style={{
                whiteSpace: "nowrap",
                maxWidth: "220px",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {customFields?.[field.id]?.questionName}
            </p>
          </Container>
        </Tooltip>
      </>
    );
  }
  if (customFields?.[field.id]?.type === "checkbox") {
    return (
      <>
        <Tooltip
          label={customFields?.[field.id]?.questionName}
          position="bottom"
        >
          <p
            style={{
              whiteSpace: "nowrap",
              maxWidth: "250px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              textAlign: "left",
            }}
          >
            <b>{customFields?.[field.id]?.questionName}:</b>
          </p>
        </Tooltip>
        <Tooltip
          label={
            customFields?.[field.id]?.questionName +
            ": " +
            field.value.map((val, index) =>
              index + 1 !== field.value.length ? val + "" : val
            )
          }
          position="bottom"
        >
          <p
            style={{
              whiteSpace: "nowrap",
              maxWidth: "250px",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {field.value.map((val, index) =>
              index + 1 !== field.value.length ? val + ", " : val + "."
            )}
          </p>
        </Tooltip>
      </>
    );
  }
};

const DeniedGuests = ({
  guest,
  hasCustomField = () => {},
  setContactInfoModalClose = () => {},
  action = () => {},
  actionHandleLoading = false,
  setIsFaceModalClose = () => {},
  customFields = {},
}) => {
  const [errorImg, setErrorImg] = useState(false);
  return (
    <div
      style={{
        borderRadius: "10px",
        boxShadow: " 0px 4px 16px 0px #00000014",
        height: "100%",
        // border: "1px solid red",
      }}
    >
      <Box sx={{ position: "relative" }}>
        <Box
          p={"32px 16px 16px 16px"}
          textAlign="center"
          sx={{
            width: "100%",
            // height: data?.email ? "" : "191.91px"
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "24 px",
              marginTop: "58px",
            }}
          >
            <p style={{ fontWeight: "700" }}>
              {guest?.firstName + " " + guest?.lastName}
            </p>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                flexDirection: "column",
                marginTop: "8px",
              }}
            >
              {guest.email && (
                <p
                  style={{
                    fontSize: "16px",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <img
                    src={mailIcon}
                    style={{
                      width: "24px",
                    }}
                  />
                  {guest.email}
                </p>
              )}
              {guest.phoneNumber && (
                <p
                  style={{
                    fontSize: "16px",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <img
                    src={phoneIcon}
                    style={{
                      width: "24px",
                    }}
                  />
                  <p>{guest?.phoneNumber}</p>
                </p>
              )}
            </div>
            <div style={{ marginTop: "8px" }}>
              <button
                onClick={() => {
                  setContactInfoModalClose(guest?.id);
                }}
                style={{
                  height: "fitContent",
                  width: "fitContent",
                  border: "1px solid var(--color-secondary-grey-40)",
                  padding: "5px 16px",
                  borderRadius: "25000px",
                  fontSize: "16px",
                  backgroundColor: "transparent",
                  color: "var(--custom-color-primary-60)",
                  fontWeight: "700",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  cursor: "pointer",
                }}
              >
                Get Contact{" "}
                <img
                  src={rightArrow}
                  style={{
                    width: "16px",
                  }}
                />
              </button>
            </div>
            <Box sx={{ "& .text-atom": { whiteSpace: "nowrap" } }}>
              <div style={{ display: "flex", gap: "8px", margin: "16px 0" }}>
                <p
                  style={{
                    backgroundColor: "var(--color-primary-50)",
                    fontSize: "12px",
                    fontWeight: "700",
                    color: "#ffff",
                    height: "fitContent",
                    width: "fitContent",
                    padding: "2px 6px",
                    borderRadius: "4px",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <img
                    src={icPhoto}
                    style={{
                      width: "16px",
                    }}
                  />
                  {guest?.access
                    ? capitalizeWords(guest?.access, "_")
                    : "No Access"}
                </p>
                <p
                  style={{
                    backgroundColor:
                      guest?.downloadAccess == "APPROVED"
                        ? "var(--color-feedback-success-50)"
                        : "var(--color-feedback-error-50)",
                    fontSize: "12px",
                    fontWeight: "700",
                    color: "#ffff",
                    height: "fitContent",
                    width: "fitContent",
                    padding: "2px 6px",
                    borderRadius: "4px",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <img
                    src={
                      guest?.downloadAccess == "APPROVED" ? icCorrect : icCross
                    }
                    style={{
                      width: "16px",
                    }}
                  />{" "}
                  Download Access
                </p>
              </div>
            </Box>
          </div>
        </Box>
        {/* custom field */}
        <div style={{ padding: "16px", borderTop: "1px solid #e0e0e0" }}>
          {hasCustomField && (
            <>
              {guest?.customField?.length > 0 && (
                <div
                  style={{
                    paddingBottom: "10px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                    width: "100%",
                  }}
                >
                  {guest?.customField?.map((item) => {
                    return customFieldsShow(customFields, item);
                  })}
                </div>
              )}
              {!guest?.customField && (
                <div
                  fullWidth
                  style={{
                    borderTop: "1px solid #e0e0e0",
                    paddingBlock: "20px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <p style={{ color: "#D3D3D3" }}>Yet to register</p>
                </div>
              )}
            </>
          )}

          <div
            style={{ display: "flex", gap: "20px", justifyContent: "center" }}
          >
            <button
              onClick={() => action("1", guest?.id)}
              style={{
                height: "fitContent",
                width: "fitContent",
                border: "1px solid var(--color-secondary-grey-40)",
                padding: "5px 16px",
                borderRadius: "25000px",
                fontSize: "16px",
                backgroundColor: "transparent",
                color: "var(--custom-color-primary-60)",
                fontWeight: "700",
                cursor: "pointer",
              }}
              disabled={actionHandleLoading}
            >
              Restore
            </button>
          </div>
        </div>

        <Box
          textAlign="center"
          sx={{
            position: "absolute",
            top: "-60px",
            left: "50%",
            transform: "translateX(-50%)",
          }}
        >
          <Box sx={{ "& .j-JDSImage-image": { height: "100%" } }}>
            <div
              style={{
                textAlign: "center",
                position: "relative",
              }}
            >
              <img
                src={
                  errorImg
                    ? brokenImg
                    : guest?.profileFile
                    ? URL.createObjectURL(guest?.profileFile)
                    : guest?.profilePictureThumbnailUrl
                    ? decryptUrl(guest?.profilePictureThumbnailUrl)
                    : avatar
                }
                onClick={() => {
                  if (guest?.profilePictureThumbnailUrl) {
                    setIsFaceModalClose();
                  }
                }}
                style={{
                  width: "120px",
                  height: "120px",
                  borderRadius: "25000px",
                  objectPosition: "center",
                  objectFit: "cover",
                }}
                onError={() => {
                  setErrorImg(true);
                }}
              />

              <span
                style={{
                  backgroundColor: "var(--color-feedback-error-50)",
                  fontSize: "12px",
                  fontWeight: "700",
                  color: "#ffff",
                  height: "fitContent",
                  width: "58px",
                  textAlign: "center",
                  padding: "1px",
                  borderRadius: "4px",
                  margin: "0",
                  position: "absolute",
                  bottom: "-6px",
                  left: "30px",
                }}
              >
                Denied
              </span>
            </div>
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default React.memo(DeniedGuests);
